module.exports = __webpack_public_path__ + "static/media/tooltip-image1.cebae796.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/tooltip-image1.png
// module id = 2745
// module chunks = 0